// This import needs to be first in order to load the polyfills before any other code
import './polyfills';

import '@sfstudios/shapeshifter/build/legacy.css';
import './index.css';
import './setBrandAttribute';
import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import Root from './Root';
import * as serviceWorker from './serviceWorker';
import { initSentry } from './utils/sentry';

initSentry();

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <StrictMode>
    <Root />
  </StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
